import React from 'react';
import logo from './logo.svg';
import './App.css';
import ClientCalculator from './ClientCalculator';

function App() {
  return (
    <div className="App">
      <ClientCalculator />
    </div>
  );
}

export default App;
